// Copyright (c) 2016 Deere & Company

import CloudConfig, {getDefaultState as getCloudConfigDefaultState} from './cloud-config';
import CscConfig, {getDefaultState as getCscConfigDefaultState} from './csc-config';
import OktaConfig, {getDefaultState as getOktaConfigDefaultState} from './okta-config';
import SapEnvironment from './sap-environment';
import t from 'tcomb';

const AppConfig = t.struct({
    cloud: CloudConfig,
    csc: CscConfig,
    okta: OktaConfig,
    sapEnvironments: t.list(SapEnvironment, 'SapEnvironments')
}, {
    name: 'AppConfig',
    strict: true
});

export const getDefaultState = () => new AppConfig({
    cloud: getCloudConfigDefaultState(),
    csc: getCscConfigDefaultState(),
    okta: getOktaConfigDefaultState(),
    sapEnvironments: []
});

export default AppConfig;



// WEBPACK FOOTER //
// ./src/shared/models/app-config.js